import StoryPlayer from "./StoryPlayer";
import StoryPlayerMemento from "./StoryPlayerMemento";

const StoryPlayerFactory = {};
export default StoryPlayerFactory;

StoryPlayerFactory.createStoryPlayer = function(story, solver) {
    return new StoryPlayer(story, solver);
};

StoryPlayerFactory.createStoryPlayerMemento = function() {
    return new StoryPlayerMemento();
};
